import React from "react";
import InteractiveReportForm from "./InteractiveReportForm";
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import { RouteComponentProps } from "react-router";

const ADMIN_GET_INTERACTIVE_REPORT = gql`
  query GetInteractiveReport($id: String!) {
    adminGetInteractiveReport(id: $id) {
      id
      name
      slug
      description
      fileName
      roles
      dataset
    }
  }
`;

const UPDATE_INTERACTIVE_REPORT = gql`
  mutation UpdateInteractiveReport(
    $id: String!
    $interactiveReport: InteractiveReportInput!
  ) {
    updateInteractiveReport(id: $id, interactiveReport: $interactiveReport) {
      interactiveReport {
        id
        name
        slug
        description
        fileName
        roles
        dataset
      }
      message
    }
  }
`;

interface InteractiveReport {
  id: string;
  name: string;
  slug: string;
  description: string;
  fileName: string;
  roles: string[];
  dataset: string;
}

interface AdminGetInteractiveReportQueryResults {
  adminGetInteractiveReport: InteractiveReport;
}

interface AdminGetInteractiveReportQueryVariables {
  id: string;
}

interface UpdateInteractiveReportMutationResults {
  updateInteractiveReport: InteractiveReport;
  message: string;
}

interface UpdateInteractiveReportMutationVariables {
  id: string;
  interactiveReport: InteractiveReport;
}

const EditInteractiveReport = (
  props: RouteComponentProps<{ id: string }>
): JSX.Element => {
  const id = props.match.params.id || "";
  return (
    <Query<
      AdminGetInteractiveReportQueryResults,
      AdminGetInteractiveReportQueryVariables
    >
      query={ADMIN_GET_INTERACTIVE_REPORT}
      variables={{ id: id }}
    >
      {({ data, error }) => {
        if (error) return "Error while getting interactive report.";

        if (!data || !data.adminGetInteractiveReport)
          return "Interactive Report not found.";

        return (
          <Mutation<
            UpdateInteractiveReportMutationResults,
            UpdateInteractiveReportMutationVariables
          >
            mutation={UPDATE_INTERACTIVE_REPORT}
          >
            {(updateInteractiveReport) => {
              return (
                <InteractiveReportForm
                  interactiveReport={data.adminGetInteractiveReport}
                  mutationFn={updateInteractiveReport}
                />
              );
            }}
          </Mutation>
        );
      }}
    </Query>
  );
};

export default EditInteractiveReport;
